import i18n from 'i18n';
import {
  commonColumnSetting,
  CreativeListCommonColumns
} from './CreativeListCommonColumnData';
import { renderColumn } from 'components/TableColumn/TableColumn';
import { OutdoorCreativeListDataProvider } from './OutdoorCreativeListDataProvider';

enum COLUMNS {
  OUTDOOR_TYPE = 'outdoorType',
  DURATION = 'duration'
}

export class HwacomCreativeListDataProvider extends OutdoorCreativeListDataProvider {
  getColumns() {
    const columns = super.getColumns();
    const approvalColumn = renderColumn(
      commonColumnSetting[CreativeListCommonColumns.APPROVAL],
      this.formatters.approvalFormatter
    );
    const approvalColumnIndex =
      columns.findIndex(
        (column) => column.dataField === CreativeListCommonColumns.PREVIEW
      ) + 1;
    columns.splice(approvalColumnIndex, 0, approvalColumn);
    const durationColumn = columns.find(
      (column) => column.dataField === COLUMNS.DURATION
    );
    if (durationColumn) {
      durationColumn.formatter = (duration) =>
        `${duration} ${i18n.t('common.units.seconds')}`;
    }
    return columns;
  }
}
